<script>
import { Component, Vue, Prop, Ref, Emit } from "vue-property-decorator";
import { rootMenu } from "src/common/control-enum";
import _ from 'lodash'
@Component({
  //   name: "multiline-button"
})
export default class baseButton extends Vue {
  @Prop({ type: String, default: null }) type;
  @Prop({ type: Boolean, default: false }) disabled;
  @Prop({ type: String, default: null }) label;
  @Prop({ type: String, default: null }) icon;
  @Prop({ type: String, default: null }) size;
  @Prop({ type: Boolean, default: false }) isRoot;
  // @Prop({ type: String, default: "" }) rootType;
  @Prop({ type: Function, default: function() {} }) render;
  @Prop({ type: String, default: null }) routerLink;
  @Prop({ type: Boolean, default: false }) loading;
  @Prop({ type: String, default: '' }) powerName;

  @Emit("click")
  click() {
  }

  get getDisabled() {
    console.log('butoon root')
    if (this.$store.getters.isAdmin) return false;
    if (this.isRoot === false) return false;
    const type = this.$route.meta.rootEnum;
    const label = this.$slots.default[0].text;
    const rootMap = `${type}_${rootMenu[label]}`;
    const auth = this.$store.getters.auth;
    if (!auth || auth[rootMap]) return false;
    return true;
  }

  get operateMap() { // 功能权限
    let operateList = JSON.parse(window.sessionStorage.getItem("operateList"));
    let resurlMap = _.groupBy(operateList,'resPrivilege')
    return resurlMap
  }

  render(h) {
    return (<el-button
        type={this.type}
        disabled={this.getDisabled || this.disabled}
        loading={this.loading}
        icon={this.icon}
        size={this.size || "small"}
        onClick={this.click}
        vShow={this.powerName ? this.operateMap[this.powerName] : true}
      >
        {this.$slots.default}
      </el-button>);
  }
}
</script>
